import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Case Battles',
    tabActive: 'Active',
    tabHistoryAll: 'Completed',
    tabHistoryMine: 'My Battles',
    createBattle: 'Create Battle',
    empty: 'No battles yet',
    emptyHint: 'Start your own — rivals will show up.',
    emptyHistory: 'No battle history',
    loading: 'Loading...',
    historyMineLoginReason: 'Sign in to see your battles.',
    refreshFailed: "Couldn't refresh — showing the last loaded battles",
    retry: 'Tap to retry',
  },
  ru: {
    title: 'Case Battles',
    tabActive: 'Активные',
    tabHistoryAll: 'Завершенные',
    tabHistoryMine: 'Мои баттлы',
    createBattle: 'Создать баттл',
    empty: 'Баттлов пока нет',
    emptyHint: 'Собери свой — соперники подтянутся.',
    emptyHistory: 'Нет истории баттлов',
    loading: 'Загрузка...',
    historyMineLoginReason: 'Войди, чтобы видеть свои баттлы.',
    refreshFailed: 'Не удалось обновить, показаны последние данные',
    retry: 'Нажми, чтобы повторить',
  },
  uz: {
    title: 'Keys Janglar',
    tabActive: 'Faol',
    tabHistoryAll: 'Tugallangan',
    tabHistoryMine: 'Mening janglarim',
    createBattle: "Jang yaratish",
    empty: 'Hozircha janglar yoʻq',
    emptyHint: 'Oʻz jangingni yarat — raqiblar keladi.',
    emptyHistory: 'Jang tarixi yoʻq',
    loading: 'Yuklanmoqda...',
    historyMineLoginReason: 'Oʻz janglaringizni koʻrish uchun kiring.',
    refreshFailed: 'Yangilab boʻlmadi — oxirgi yuklangan janglar koʻrsatilmoqda',
    retry: 'Qayta urinish uchun bos',
  },
  fa: {
    title: 'نبرد کیس',
    tabActive: 'فعال',
    tabHistoryAll: 'تمام‌شده',
    tabHistoryMine: 'نبردهای من',
    createBattle: 'ساخت نبرد',
    empty: 'هنوز نبردی نیست',
    emptyHint: 'نبرد خودت را بساز — حریف‌ها می‌آیند.',
    emptyHistory: 'تاریخچه نبردی نیست',
    loading: 'در حال بارگذاری...',
    historyMineLoginReason: 'وارد شو تا نبردهایت را ببینی.',
    refreshFailed: 'به‌روزرسانی نشد — آخرین نبردهای بارگذاری‌شده را نشان می‌دهیم',
    retry: 'برای تلاش دوباره بزن',
  },
  pt: {
    title: 'Batalhas de caixas',
    tabActive: 'Ativas',
    tabHistoryAll: 'Concluídas',
    tabHistoryMine: 'Minhas batalhas',
    createBattle: 'Criar batalha',
    empty: 'Ainda não há batalhas',
    emptyHint: 'Crie a sua — os rivais vão aparecer.',
    emptyHistory: 'Sem histórico de batalhas',
    loading: 'Carregando...',
    historyMineLoginReason: 'Entre para ver suas batalhas.',
    refreshFailed: 'Não foi possível atualizar — mostrando os últimos dados',
    retry: 'Toque para tentar de novo',
  },
  tr: {
    title: 'Kasa savaşları',
    tabActive: 'Aktif',
    tabHistoryAll: 'Biten',
    tabHistoryMine: 'Savaşlarım',
    createBattle: 'Savaş oluştur',
    empty: 'Henüz savaş yok',
    emptyHint: 'Kendi savaşını kur — rakipler gelir.',
    emptyHistory: 'Savaş geçmişi yok',
    loading: 'Yükleniyor...',
    historyMineLoginReason: 'Savaşlarını görmek için giriş yap.',
    refreshFailed: 'Yenilenemedi — son yüklenen veriler gösteriliyor',
    retry: 'Tekrar denemek için dokun',
  },
  uk: {
    title: 'Кейс-батли',
    tabActive: 'Активні',
    tabHistoryAll: 'Завершені',
    tabHistoryMine: 'Мої батли',
    createBattle: 'Створити батл',
    empty: 'Батлів поки немає',
    emptyHint: 'Створи свій — суперники підтягнуться.',
    emptyHistory: 'Історії батлів немає',
    loading: 'Завантаження...',
    historyMineLoginReason: 'Увійди, щоб бачити свої батли.',
    refreshFailed: 'Не вдалося оновити, показано останні дані',
    retry: 'Натисни, щоб повторити',
  },
  de: {
    title: 'Case Battles',
    tabActive: 'Aktiv',
    tabHistoryAll: 'Beendet',
    tabHistoryMine: 'Meine Battles',
    createBattle: 'Battle erstellen',
    empty: 'Noch keine Battles',
    emptyHint: 'Erstell dein eigenes – die Gegner kommen von allein.',
    emptyHistory: 'Kein Battle-Verlauf',
    loading: 'Lädt...',
    historyMineLoginReason: 'Logge dich ein, um deine Battles zu sehen.',
    refreshFailed: 'Aktualisieren fehlgeschlagen – zuletzt geladene Battles werden angezeigt',
    retry: 'Tippen zum Wiederholen',
  },
  es: {
    title: 'Case Battles',
    tabActive: 'Activos',
    tabHistoryAll: 'Finalizados',
    tabHistoryMine: 'Mis battles',
    createBattle: 'Crear battle',
    empty: 'Aún no hay battles',
    emptyHint: 'Crea el tuyo y los rivales aparecerán.',
    emptyHistory: 'No hay historial de battles',
    loading: 'Cargando...',
    historyMineLoginReason: 'Inicia sesión para ver tus battles.',
    refreshFailed: 'No se pudo actualizar; se muestran los últimos battles cargados',
    retry: 'Toca para reintentar',
  },
  pl: {
    title: 'Case Battles',
    tabActive: 'Aktywne',
    tabHistoryAll: 'Zakończone',
    tabHistoryMine: 'Moje battle',
    createBattle: 'Utwórz battle',
    empty: 'Na razie nie ma battle',
    emptyHint: 'Stwórz własny — rywale się znajdą.',
    emptyHistory: 'Brak historii battle',
    loading: 'Ładowanie...',
    historyMineLoginReason: 'Zaloguj się, aby zobaczyć swoje battle.',
    refreshFailed: 'Nie udało się odświeżyć — pokazujemy ostatnio wczytane battle',
    retry: 'Dotknij, aby spróbować ponownie',
  },
});
